import React from 'react';
import { FlexibilityIcon } from 'src/components/Quiz/Icons/FlexibilityIcon';
import { StudentSupportIcon } from 'src/components/Quiz/Icons/StudentSupportIcon';
import { TimeIcon } from 'src/components/Quiz/Icons/TimeIcon';
import { InstitutionIcon } from 'src/components/Quiz/Icons/InstitutionIcon';

export interface ProgramFactorCategory {
	icon: React.ReactNode;
	label: string;
}

export const programFactorCategories = [
	{
		icon: <InstitutionIcon size={37} />,
		label: 'University name recognition',
	},
	{
		icon: <FlexibilityIcon size={36} />,
		label: 'Flexibility',
	},
	{
		icon: <StudentSupportIcon size={35} />,
		label: 'Student support',
	},
	{
		icon: <TimeIcon size={39} />,
		label: 'Time to completion',
	},
];
